import SuccessMessage from 'common/SuccessMessage';
import EmailLayout from 'emails/EmailLayout/EmailLayout';

import React from 'react';
import { Section, Button, Heading } from '@react-email/components';
import Regards from './common/Regards';

const AccountCreated = ({ name, email }) => {
    return (
        <EmailLayout>
            <div className="heading">
                <SuccessMessage className="created">Account Created!</SuccessMessage>
                <Heading>Welcome to Be:Seen Health, {name}</Heading>
            </div>

            <Section style={{ textAlign: 'center', marginTop: '40px' }}>
                <Button
                    href={`${process.env.REACT_APP_PATIENT_PORTAL_URL}/auth/signup?email=${encodeURIComponent(email)}`}
                    style={{
                        padding: '10px 30px',
                        backgroundColor: '#FF5F39',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '28px',
                        cursor: 'pointer',
                        fontSize: '18px',
                        fontWeight: 500,
                        fontFamily: 'Poppins, sans-serif',
                    }}
                >
                    Go to BeSeenHealth.com
                </Button>
            </Section>

            <div style={{ textAlign: 'center', marginTop: '40px' }}>
                <p
                    style={{
                        color: '#999',
                        fontSize: '14px',
                        textAlign: 'left',
                    }}
                >
                    You can explore our platform and start searching for providers right away. If you have any
                    questions, our support team is here to help.
                </p>
            </div>

            <div style={{ textAlign: 'center', marginTop: '40px' }}>
                <div
                    style={{
                        color: '#1F1E2C',
                        fontFamily: 'Poppins,sans-serif',
                        fontSize: '16px',
                        fontWeight: 700,
                        display: 'flex',
                    }}
                    className="congrats"
                >
                    Congratulations!
                </div>

                <div
                    style={{
                        fontWeight: 400,
                        display: 'flex',
                        justifyContent: 'flex-start',
                        marginBottom: '40px',
                        textAlign: 'left',
                    }}
                    className="accountCreatedText"
                >
                    Your account has been successfully created. We're excited to have you on board. Next time you
                    log in, you'll be able to easily search for, book, and pay for appointments with top health
                    providers in your area.
                </div>

                <div
                    style={{
                        fontWeight: 400,
                        display: 'flex',
                        justifyContent: 'flex-start',
                        marginBottom: '40px',
                        textAlign: 'left',
                    }}
                    className="accountCreatedText"
                >
                    We're here to make your healthcare journey smooth and stress-free.
                </div>

                <Section>
                    <Regards />
                </Section>
            </div>
        </EmailLayout>
    );
};

export default AccountCreated;
